import Axios from "axios";
import React, { useState } from "react";
import { AiFillDelete } from "react-icons/ai";

const SlotElement = ({
  slot,
  competition,
  participants,
  level,
  givenSlot,
  setGivenSlot,
}) => {
  const [deleteDisabled, setDeleteDisabled] = useState(false);

  let phoneNo = competition.isTeamCompi
    ? participants.find((element) => element.teamId === slot.userTeamId)
      ? participants.find((element) => element.teamId === slot.userTeamId).phone
      : ""
    : participants.find((element) => element.crId === slot.userTeamId)
    ? participants.find((element) => element.crId === slot.userTeamId).phone
    : "";

  const deleteSlot = () => {
    setDeleteDisabled(true);
    if (level === "") {
      Axios.post(
        "https://ashish.moodi.org/competitions/delete_slot",
        {
          participantId: slot.participantId,
          competition: competition.competitionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setGivenSlot(
              givenSlot.filter(
                (element) => element.participantId !== slot.participantId
              )
            );
            setDeleteDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    } else if (level === "semis") {
      Axios.post(
        "https://ashish.moodi.org/competitions/delete_semis_slot",
        {
          participantId: slot.participantId,
          competition: competition.competitionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setGivenSlot(
              givenSlot.filter(
                (element) => element.participantId !== slot.participantId
              )
            );
            setDeleteDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    } else if (level === "finals") {
      Axios.post(
        "https://ashish.moodi.org/competitions/delete_finals_slot",
        {
          participantId: slot.participantId,
          competition: competition.competitionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setGivenSlot(
              givenSlot.filter(
                (element) => element.participantId !== slot.participantId
              )
            );
            setDeleteDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-sm-2">
          {competition.isTeamCompi
            ? participants.find((element) => element.teamId === slot.userTeamId)
              ? participants.find(
                  (element) => element.teamId === slot.userTeamId
                ).MI_NO
              : ""
            : participants.find((element) => element.crId === slot.userTeamId)
            ? participants.find((element) => element.crId === slot.userTeamId)
                .MI_NO
            : ""}
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-2">{slot.slotNumber}</div>
        <a href={`tel:${phoneNo}`} className="col-sm-3 ">
          {phoneNo}
        </a>
        <div className="col-sm-1">
          {deleteDisabled ? (
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          ) : (
            <AiFillDelete
              color="red"
              size={25}
              style={{ cursor: "pointer" }}
              onClick={deleteSlot}
            />
          )}
        </div>
      </div>
      <hr />
    </>
  );
};

export default SlotElement;
